import { ConfirmTermsOfServiceRequest, ConfirmTermsOfServiceResponse } from '../confirmtermsofservice';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';

export async function confirmTermsOfService(accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<ConfirmTermsOfServiceResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const request: ConfirmTermsOfServiceRequest = {};
        const encodedRequest = ConfirmTermsOfServiceRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = "https://nh4b502uqb.execute-api.us-west-2.amazonaws.com/authservice/confirmtermsofservice";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): ConfirmTermsOfServiceResponse => {
        return ConfirmTermsOfServiceResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
